"use strict";

window.neptune.locationsearch = {
  init: function () {
    var x = document.querySelectorAll('.js-get-location');
    if (x.length == 0) {
      return;
    }
    if (navigator.geolocation == null) {
      return;
    }
    x.forEach(e => {
      e.addEventListener("click", c => {
        c.preventDefault();
        var options = {
          enableHighAccuracy: true,
          maximumAge: 30000,
          timeout: 27000
        };
        var pageUrl = (Shopify.routes.root.length > 1 ? Shopify.routes.root : "/") + "pages/store-search-results?";
        var success = data => {
          var url = pagurl + "latLng=" + data.coords.latitude + "," + data.coords.longitude;
          window.location.href = url;
        };
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(success, () => {
            window.location.href = pageUrl;
          }, options);
        } else {
          error();
        }
      });
    });
  }
};